import React from 'react';
import classNames from 'classnames';
import { t } from '../../../../../i18n';
import { formatCoursePrice } from '../../../../utilities';
import './styles.scss';

const CoursePreview = ({ course: { title, previewImageUrlSmall, previewImageUrlLarge, price } = {}, className }) => (
  <div className={classNames('checkout-course-preview', className)}>
    <h2>{t('DIGITAL_COURSES.CHECKOUT.COURSE_TITLE')}</h2>
    {price ? (
      <div className="checkout-course-preview__course-item">
        <div className="checkout-course-preview__thumbnail">
          <picture>
            <source media="(min-width: 1000px)" srcSet={previewImageUrlLarge} />
            <img src={previewImageUrlSmall} alt={title} className="checkout-course-preview__thumbnail-image" />
          </picture>
        </div>
        <p className="checkout-course-preview__course-title">{title}</p>
        {price.isDiscountApplied ? (
          <div className="checkout-course-preview__price-with-discount-wrapper">
            <strong className="checkout-course-preview__original-course-price">
              {formatCoursePrice({ amount: price.originalAmount, currency: price.currency })}
            </strong>
            <strong className="checkout-course-preview__discount-course-price">{formatCoursePrice(price)}</strong>
            <strong className="checkout-course-preview__discount-percentage-text">{`${t('DISCOUNT')}: ${
              price.discountPercentage
            }%`}</strong>
          </div>
        ) : (
          <strong className="checkout-course-preview__course-price">{formatCoursePrice(price)}</strong>
        )}
      </div>
    ) : (
      <div className={classNames('checkout-course-preview__placeholder', 'placeholder-glow')}>
        <div className="placeholder" />
      </div>
    )}
  </div>
);

export default CoursePreview;
